import Vue from 'vue'
import VueRouter from 'vue-router'
/* Layouts */
import Layout1 from '../layouts/Layout1'
import Layout2 from '../layouts/Layout2'
import Layout3 from '../layouts/Layout3'
/**
 * Referral Partner
 */
import Layout4 from '../layouts/Layout4'
import AuthLayout1 from '../layouts/AuthLayouts/AuthLayout1'
import AuthLayout2 from '../layouts/AuthLayouts/AuthLayout2'
import SignIn from '../views/AuthPages/Default/SignIn'
import * as auth from '../services/auth.service';
Vue.use(VueRouter)


/**
 * Admin
 * @param {*} prop
 * @param {*} mode
 * @returns
 */
const adminChildRoute = (prop, mode = false) => [
    /*Dashboard*/
    {
      path: '/',
      name: prop +'.dashboard',
      meta: { auth: true, name: 'Home 1' },
      component:() => import('../views/Admin/Dashboard.vue'),
    },
    {
      path: 'reporting',
      name: prop +'.reporting',
      component:() => import('../views/Admin/Reports/Reporting.vue'),
    },
    {
      path: 'reporting-bdm',
      name: prop +'.reporting-bdm',
      component:() => import('../views/Reports/BDM/ReportingBDM.vue'),
    },
    {
      path: 'invoicing',
      name: prop +'.invoicing',
      component:() => import('../views/Admin/Invoices/Invoicing.vue'),
    },
    {
      path: 'user-list',
      name: prop +'.userList',
      component:() => import('../views/Admin/UserList.vue'),
    },
    {
      path: 'user-list/designation-list',
      name: prop +'.designationList',
      component:() => import('../views/Admin/Settings/DesignationList.vue'),
    },
    /**
     * Leads-Start
     */
    {
      path: 'leads-list',
      name: prop +'.leadsList',
      component:() => import('../views/Admin/Leads/LeadsList.vue'),
    },
    {
      path: 'leads-new',
      name: prop +'.LeadsNew',
      component:() => import('../views/Admin/Leads/LeadsNew.vue'),
    },
    {
      path: 'leads-view/:quoteId',
      name: prop +'.leadsView',
      component:() => import('../views/Admin/Leads/LeadsView.vue'),
    },
    {
      path: 'leads-edit/:quoteId',
      name:  prop +'.leadsEdit',
      component:() => import('../views/Admin/Leads/LeadsEdit.vue'),
    },
    /**
     * Leads-End
     */
    {
      path: 'dealers',
      name: prop +'.dealers',
      component:() => import('../views/Admin/Dealer/DealerList.vue'),
    },
    {
      path: 'referral_partner',
      name: prop +'.referralPartner',
      component:() => import('../views/Admin/ReferralPartner/ReferralPartner.vue'),
    },
    {
      path: 'employer',
      name: prop +'.employer',
      component:() => import('../views/Admin/Employer/Employer.vue'),
    },
    {
      path: 'profile',
      name: prop +'.profile',
      component:() => import('../views/AuthPages/Default/Profile.vue'),
    },
    {
      path: 'password-change',
      name: prop +'.passwordChange',
      component:() => import('../views/AuthPages/Default/PasswordChange.vue'),
    },
    {
      path: 'terms-of-use',
      name: prop +'.termsOfUse',
      component:() => import('../views/Common/TermsOfUse.vue'),
    },
    {
      path: 'privacy-policy',
      name: prop +'.privacyPolicy',
      component:() => import('../views/Common/PrivacyPolicy.vue'),
    },
    /*chat system*/
    {
      path: 'chat-list',
      name: prop +'.chatList',
      component:() => import('../views/ChatSystem/List.vue'),
    },

    /*Quote*/
    /**
     * Server side pagination quote list
     */
    {
      path: 'quote-list',
      name: prop +'.quoteList',
      meta: { auth: true, name: 'Quotes' },
      component:() => import('../views/Admin/Quote/QuoteList.vue'),
    },
    {

      path: 'quote-view/:quoteId',
      name: prop +'.quoteView',
      component:() => import('../views/Admin/Quote/QuoteView.vue'),
    },
    {
      path: 'quote-new',
      name: prop +'.quoteNew',
      component:() => import('../views/Admin/Quote/QuoteNew.vue'),
    },
    {
      path: 'quote-edit/:quoteId',
      name:  prop +'.quoteEdit',
      component:() => import('../views/Admin/Quote/QuoteEdit.vue'),
    },
     // Cars
    {
      path: 'cars',
      name: prop +'.cars',
      component:() => import('../views/Admin/Cars/CarList.vue'),
    },
    {
      path: 'cars/new',
      name: prop +'.carsNew',
      component:() => import('../views/Admin/Cars/CarNew.vue'),
    },
    {
      path: 'cars/edit/:id',
      name: prop +'.carsEdit',
      component:() => import('../views/Admin/Cars/CarEdit.vue'),
    },
    //Car Category
    {
      path: 'car-category-list',
      name: prop +'.carCategoryList',
      component:() => import('../views/Admin/Cars/CarCategoryList.vue'),
    },

    //Maturing Leasing
    {
      path: 'maturing-leas-list',
      name: prop +'.maturingLeasList',
      component:() => import('../views/Admin/MaturingLeases/MaturingLeasList.vue'),
    },
    {

      path: 'maturing/quote-view/:quoteId',
      name: prop +'.maturingQuoteView',
      component:() => import('../views/Admin/MaturingLeases/MaturingQuoteView.vue'),
    },

    // Settings
    {
      path: 'settings',
      name: prop +'.settings',
      component:() => import('../views/Admin/Settings/PayPeriod.vue'),
    },
    {
      path: 'settings/pay-period',
      name: prop +'.payPeriod',
      component:() => import('../views/Admin/Settings/PayPeriod.vue'),
    },
    {
      path: 'settings/salary-packaging-provider',
      name: prop +'.salaryPackagingProvider',
      component:() => import('../views/Admin/Settings/SalaryPackagingProvider.vue'),
    },
    {
      path: 'settings/lease-term',
      name: prop +'.leaseTerm',
      component:() => import('../views/Admin/Settings/LeaseTerm.vue'),
    },
    {
      path: 'settings/business-use-percentage',
      name: prop +'.businessUsePercentage',
      component:() => import('../views/Admin/Settings/BusinessUsePercentage.vue'),
    },
    {
      path: 'settings/vehicle-condition',
      name: prop +'.vehicleCondition',
      component:() => import('../views/Admin/Settings/VehicleCondition.vue'),
    },
    {
      path: 'settings/vehicle-category',
      name: prop +'.vehicleCategory',
      component:() => import('../views/Admin/Settings/VehicleCategory.vue'),
    },
    {
      path: 'settings/transmission',
      name: prop +'.transmission',
      component:() => import('../views/Admin/Settings/Transmission.vue'),
    },
    {
      path: 'settings/fuel-type',
      name: prop +'.fuelType',
      component:() => import('../views/Admin/Settings/FuelType.vue'),
    },
    {
      path: 'settings/australian-residency-status',
      name: prop +'.australianResidencyStatus',
      component:() => import('../views/Admin/Settings/AustralianResidencyStatus.vue'),
    },
    {
      path: 'settings/drivers-licence-type',
      name: prop +'.driversLicenceType',
      component:() => import('../views/Admin/Settings/DriversLicenceType.vue'),
    },
    {
      path: 'settings/employment-status',
      name: prop +'.employmentStatus',
      component:() => import('../views/Admin/Settings/EmploymentStatus.vue'),
    },
    {
      path: 'settings/residential-status',
      name: prop +'.residentialStatus',
      component:() => import('../views/Admin/Settings/ResidentialStatus.vue'),
    },
    {
      path: 'settings/visa-type',
      name: prop +'.visaType',
      component:() => import('../views/Admin/Settings/VisaType.vue'),
    },
    {
      path: 'settings/other-income',
      name: prop +'.otherIncome',
      component:() => import('../views/Admin/Settings/OtherIncome.vue'),
    },
    {
      path: 'settings/other-loan',
      name: prop +'.otherLoan',
      component:() => import('../views/Admin/Settings/OtherLoan.vue'),
    },
    {
      path: 'settings/document-type',
      name: prop +'.documentType',
      component:() => import('../views/Admin/Settings/DocumentType.vue'),
    },


    {
      path: 'settings/forms-download',
      name: prop +'.formsDownload',
      component:() => import('../views/Admin/Settings/FormDownload.vue'),
    },
    {
      path: 'settings/faq',
      name: prop +'.faq',
      component:() => import('../views/Admin/Settings/Faq.vue'),
    },


    // system settings
    {
      path: 'systems',
      name: prop +'.systems',
      component:() => import('../views/Admin/Settings/SystemSettings.vue'),
    },
    {
      path: 'systems/financier',
      name: prop +'.financier',
      component:() => import('../views/Admin/Settings/Financier.vue'),
    },
    {
      path: 'systems/lookup-values',
      name: prop +'.lookupValues',
      component:() => import('../views/Admin/Settings/LookupValues.vue'),
    },
    {
      path: 'systems/tax-table',
      name: prop +'.taxTable',
      component:() => import('../views/Admin/Settings/TaxTable.vue'),
    },
    {
      path: 'systems/quote-logs/:quoteId',
      name:  prop +'.quoteLogs',
      component:() => import('../views/Logs/Single.vue'),
    },
    {
      path: 'systems/em-document',
      name:  prop +'.emDocument',
      component:() => import('../views/Admin/Settings/EMDocument.vue'),
    },
    {
      path: 'system-settings/email-template',
      name:  prop +'.emailTemplate',
      component:() => import('../views/Admin/Settings/EmailTemplate.vue'),
    },


    {
      // Forms
      path: 'forms',
      name:  prop +'.forms',
      component:() => import('../views/Admin/Forms.vue'),
    },
    {
      //FAQ's
      path: 'faqs',
      name:  prop +'.faqs',
      component:() => import('../views/Admin/FAQS.vue'),
    },
    {
      // Marketing
      path: 'marketing',
      name:  prop +'.marketing',
      component:() => import('../views/Admin/Marketing.vue'),
    },
    {
       // Marketing Employer
       path: 'marketing-employer',
       name:  prop +'.marketingEmployer',
       component:() => import('../views/Marketing/MarketingEmployer.vue'),
    },
]

/**
 * BDM
 * @param {*} prop
 * @param {*} mode
 * @returns
 */
const bdmChildRoute = (prop, mode = false) => [

  {
    path: '',
    name: prop +'.dashboard',
    // meta: { auth: true, name: 'Home 1' },
    component:() => import('../views/BDM/Dashboard.vue'),
  },
  {
    path: 'reporting',
    name: prop +'.reporting',
    component:() => import('../views/BDM/Reports/Reporting.vue'),
  },
  {
    path: 'profile',
    name: prop +'.profile',
    component:() => import('../views/AuthPages/Default/Profile.vue'),
  },
  {
    path: 'password-change',
    name: prop +'.passwordChange',
    component:() => import('../views/AuthPages/Default/PasswordChange.vue'),
  },
  {
    path: 'terms-of-use',
    name: prop +'.termsOfUse',
    component:() => import('../views/Common/TermsOfUse.vue'),
  },
  {
    path: 'privacy-policy',
    name: prop +'.privacyPolicy',
    component:() => import('../views/Common/PrivacyPolicy.vue'),
  },
  /*chat system*/
  {
    path: 'chat-list',
    name: prop +'.chatList',
    component:() => import('../views/ChatSystem/List.vue'),
  },

  //Maturing Leasing
  {
      path: 'maturing-leas-list',
      name: prop +'.maturingLeasList',
      component:() => import('../views/Admin/MaturingLeases/MaturingLeasList.vue'),
  },
  {

    path: 'maturing/quote-view/:quoteId',
    name: prop +'.maturingQuoteView',
    component:() => import('../views/Admin/MaturingLeases/MaturingQuoteView.vue'),
  },
  // Referral Partner
  {
    path: 'referral_partner',
    name: prop +'.referralPartner',
    component:() => import('../views/Admin/ReferralPartner/ReferralPartner.vue'),
  },

  /**
 * Leads-Start
 */
    {
    path: 'leads-list',
    name: prop +'.leadsList',
    component:() => import('../views/BDM/Leads/LeadsList.vue'),
  },
  {
    path: 'leads-new',
    name: prop +'.LeadsNew',
    component:() => import('../views/BDM/Leads/LeadsNew.vue'),
  },
  {
    path: 'leads-edit/:quoteId',
    name:  prop +'.leadsEdit',
    component:() => import('../views/BDM/Leads/LeadsEdit.vue'),
  },
  {
    path: 'leads-view/:quoteId',
    name: prop +'.leadsView',
    component:() => import('../views/Admin/Leads/LeadsView.vue'),
  },




  /*Quote*/
  {
    path: 'quote-list',
    name: prop +'.quoteList',
    meta: { auth: true, name: 'Quotes' },
    component:() => import('../views/BDM/Quote/QuoteList.vue'),
  },
  {
    path: 'quote-view/:quoteId',
    name: prop +'.quoteView',
    component:() => import('../views/Admin/Quote/QuoteView.vue'),
  },
  {
    path: 'quote-new',
    name: prop +'.quoteNew',
    component:() => import('../views/BDM/Quote/QuoteNew.vue'),
  },
  {
    path: 'quote-edit/:quoteId',
    name:  prop +'.quoteEdit',
    component:() => import('../views/BDM/Quote/QuoteEdit.vue'),
  },

  {
    // Forms
    path: 'forms',
    name:  prop +'.forms',
    component:() => import('../views/BDM/Forms.vue'),
  },
  {
    //FAQ's
    path: 'faqs',
    name:  prop +'.faqs',
    component:() => import('../views/BDM/FAQS.vue'),
  },
  {
    // Marketing
    path: 'marketing',
    name:  prop +'.marketing',
    component:() => import('../views/BDM/Marketing.vue'),
  },
  {
    path: 'employer',
    name: prop +'.employer',
    component:() => import('../views/Admin/Employer/Employer.vue'),
  },
]




/**
 * Dealer
 * @param {*} prop
 * @param {*} mode
 * @returns
 */
const dealerChildRoute = (prop, mode = false) => [

  {
    path: '',
    name: prop +'.dashboard',
    // meta: { auth: true, name: 'Home 1' },
    component:() => import('../views/Dealer/Dashboard.vue'),
  },
  {
    path: 'reporting',
    name: prop +'.reporting',
    component:() => import('../views/Dealer/Reports/Reporting.vue'),
  },
  {
    path: 'profile',
    name: prop +'.profile',
    component:() => import('../views/AuthPages/Default/Profile.vue'),
  },
  {
    path: 'password-change',
    name: prop +'.passwordChange',
    component:() => import('../views/AuthPages/Default/PasswordChange.vue'),
  },
  {
    path: 'terms-of-use',
    name: prop +'.termsOfUse',
    component:() => import('../views/Common/TermsOfUse.vue'),
  },
  {
    path: 'privacy-policy',
    name: prop +'.privacyPolicy',
    component:() => import('../views/Common/PrivacyPolicy.vue'),
  },
  /*chat system*/
  {
    path: 'chat-list',
    name: prop +'.chatList',
    component:() => import('../views/ChatSystem/List.vue'),
  },

  /**
 * Leads-Start
 * Check this code need to remove with associated files: 2025-03-04
 */
  // {
  //   path: 'leads-list',
  //   name: prop +'.leadsList',
  //   component:() => import('../views/Dealer/Leads/LeadsList.vue'),
  // },
  // {
  //   path: 'leads-new',
  //   name: prop +'.LeadsNew',
  //   component:() => import('../views/Dealer/Leads/LeadsNew.vue'),
  // },
  // {
  //   path: 'leads-edit/:quoteId',
  //   name:  prop +'.leadsEdit',
  //   component:() => import('../views/Dealer/Leads/LeadsEdit.vue'),
  // },
  // {
  //   path: 'leads-view/:quoteId',
  //   name: prop +'.leadsView',
  //   component:() => import('../views/Dealer/Leads/LeadsView.vue'),
  // },


  /**
 * Dealer Refer Leads-Start
 */
  {
    path: 'refer-leads-list',
    name: prop +'.referLeadsList',
    component:() => import('../views/Dealer/ReferLeads/List.vue'),
  },
  {
    path: 'refer-leads-new',
    name: prop +'.referLeadsNew',
    component:() => import('../views/Dealer/ReferLeads/New.vue'),
  },
  {
    path: 'refer-leads-view/:quoteId',
    name: prop +'.referLeadsView',
    component:() => import('../views/Dealer/ReferLeads/View.vue'),
  },


  /*Quote*/
  {
    path: 'quote-list',
    name: prop +'.quoteList',
    meta: { auth: true, name: 'Quotes' },
    component:() => import('../views/Dealer/Quote/QuoteList.vue'),
  },
  {
    path: 'quote-view/:quoteId',
    name: prop +'.quoteView',
    component:() => import('../views/Admin/Quote/QuoteView.vue'),
  },
  {
    path: 'quote-new',
    name: prop +'.quoteNew',
    component:() => import('../views/Dealer/Quote/QuoteNew.vue'),
  },
  {
    path: 'quote-edit/:quoteId',
    name:  prop +'.quoteEdit',
    component:() => import('../views/Dealer/Quote/QuoteEdit.vue'),
  },

  {
    // Forms
    path: 'forms',
    name:  prop +'.forms',
    component:() => import('../views/Dealer/Forms.vue'),
  },
  {
    //FAQ's
    path: 'faqs',
    name:  prop +'.faqs',
    component:() => import('../views/Dealer/FAQS.vue'),
  },
  {
    // Marketing
    path: 'marketing',
    name:  prop +'.marketing',
    component:() => import('../views/Dealer/Marketing.vue'),
  },
]

/**
 * Referral partner (Referral partner)
 * @param {*} prop
 * @param {*} mode
 * @returns
 */
const referralPartnerChildRoute = (prop, mode = false) => [
  /*Dashboard*/
  {
    path: '',
    name: prop +'.dashboard',
    component:() => import('../views/ReferralPartner/Dashboard.vue'),
  },
  {
    path: 'reporting',
    name: prop +'.reporting',
    component:() => import('../views/ReferralPartner/Reports/Reporting.vue'),
  },
  {
    path: 'profile',
    name: prop +'.profile',
    component:() => import('../views/AuthPages/Default/Profile.vue'),
  },
  {
    path: 'password-change',
    name: prop +'.passwordChange',
    component:() => import('../views/AuthPages/Default/PasswordChange.vue'),
  },
  {
    path: 'terms-of-use',
    name: prop +'.termsOfUse',
    component:() => import('../views/Common/TermsOfUse.vue'),
  },
  {
    path: 'privacy-policy',
    name: prop +'.privacyPolicy',
    component:() => import('../views/Common/PrivacyPolicy.vue'),
  },

  /**
 * Leads-Start
 */
  {
    path: 'leads-list',
    name: prop +'.leadsList',
    component:() => import('../views/ReferralPartner/Leads/LeadsList.vue'),
  },
  {
    path: 'refer-leads-new',
    name: prop +'.referLeadsNew',
    component:() => import('../views/ReferralPartner/Leads/New.vue'),
  },
]


const authChildRoutes1 = (prop, mode = false) => [
  {
    path: '/',
    name: prop + '.sign-in',
    component: SignIn
  },
  // {
  //   path: 'sign-up',
  //   name: prop + '.sign-up',
  //   component: SignUp
  // },

  // {
  //   path: 'lock-screen1',
  //   name: prop + '.lock-screen1',
  //   meta: { dark: mode, auth: true },
  //   component: LockScreen1
  // },
  // {
  //   path: 'confirm-mail1',
  //   name: prop + '.confirm-mail1',
  //   meta: { dark: mode, auth: true },
  //   component: ConfirmMail1
  // }
]

const authChildRoutes2 = (prop, mode = false) => [
  {
    path: 'sign-up',
    name: prop + '.sign-up',
    component:() => import('../views/AuthPages/Default/SignUp'),
  },
  // Welcome message after Registering

  {
    path: 'sign-up-welcome-message',
    name: prop + '.signUpWelcomeMsg',
    component:() => import('../views/AuthPages/Default/SignUpWelcomeMsg'),
  },
  {
    // Recover password
    path: 'recover-password',
    name: prop + '.recoverPassword',
    component:() => import('../views/AuthPages/Default/RecoverPassword'),
  },

  {
    // Forget password welcome message
    path: 'recover-password-message',
    name: prop + '.recoverPasswordMessage',
    component:() => import('../views/AuthPages/Default/RecoverPasswordMessage'),
  },
  {
    // Forget password send with code
    path: 'reset-password/:code',
    name: prop + '.resetPassword',
    component:() => import('../views/AuthPages/Default/ResetPassword'),
  },
  {
    // Verify-account account
    path: 'verify-account/:code',
    name: prop + '.verifyAccount',
    component:() => import('../views/AuthPages/Default/VerifyAccount'),
  },
  {
    // Account verification message
    path: 'verification-message',
    name: prop + '.verificationMessage',
    component:() => import('../views/AuthPages/Default/VerificationMessage'),
  },
]





const routes = [
/*Hiro works*/
{
  path: '/',
  component: AuthLayout1,
  // meta: { auth: true },
  children: authChildRoutes1('auth'),
},
{
  path: '/',
  component: AuthLayout2,
  // meta: { auth: true },
  children: authChildRoutes2('auth')
},
{
  path: '/admin',
  component: Layout1,
  // meta: { auth: true },
  children: adminChildRoute('admin'),
  beforeEnter(to, from, next){
    if(!auth.isLoggedIn()){
        next('/');
    }else{
        const userObj = auth.getUserFromToken();
        const  roles  = [1, 2];

        if (roles.includes(Number(userObj.role_id))) {
          next()
        }else{
          next('/');
        }
    }
  }
},
{
  path: '/bdm',
  component: Layout2,
  // meta: { auth: true },
  children: bdmChildRoute('bdm'),
  beforeEnter(to, from, next){
    if(!auth.isLoggedIn()){
        next('/');
    }else{
        const userObj = auth.getUserFromToken();
        const  roles  = [3];

        if (roles.includes(Number(userObj.role_id))) {
          next()
        }else{
          next('/');
        }
    }
  }
},
{
  path: '/dealer',
  component: Layout3,
  // meta: { auth: true },
  children: dealerChildRoute('dealer'),
  beforeEnter(to, from, next){
    if(!auth.isLoggedIn()){
        next('/');
    }else{
        const userObj = auth.getUserFromToken();
        const  roles  = [4];

        if (roles.includes(Number(userObj.role_id))) {
          next()
        }else{
          next('/');
        }
    }
  }
},
{
  path: '/referral-partner',
  component: Layout4,
  // meta: { auth: true },
  children: referralPartnerChildRoute('referralPartner'),
  beforeEnter(to, from, next){
    if(!auth.isLoggedIn()){
        next('/');
    }else{
        const userObj = auth.getUserFromToken();
        const  roles  = [5];

        if (roles.includes(Number(userObj.role_id))) {
          next()
        }else{
          next('/');
        }
    }
  }
},


//To Print EOMSummarySettlementPrint
{
  path: '/admin/vsa-eom-summary-settlement-report-print',
  name: 'VSAEOMSummarySettlementReportPrintAdmin',
  component:() => import('../views/Admin/Reports/VSAEOMSummarySettlementReportPrint'),
},
{
  path: '/admin/vsa-eom-management-report-print',
  name: 'VSAEOMManagementReportPrintAdmin',
  component:() => import('../views/Admin/Reports/VSAEOMManagementReportPrint'),
},
{
  path: '/dealer/dealer-ship-income-report-print',
  name: 'DealerShipIncomeReportPrintDealer',
  component:() => import('../views/Dealer/Reports/DealerShipIncomeReportPrint.vue'),
},

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.VUE_APP_BASE_URL,
  routes
})

export default router
